import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import Injector from '@agritask/js-utils/libs/inject/Injector';
import { UserRole } from '../hooks/useUserRole';
import { HEADER_PANEL_API } from '../inject/ServiceId';
const languageNameMapImport = () => import(/* webpackChunkName: "language-name-map" */ 'language-name-map');
export const DEFAULT_LANGUAGE_CODE = 'en';
export const DEFAULT_LANGUAGE_DIRECTION = 'ltr';
export const generalStoreKey = 'General store';
export const useGeneralStore = defineStore(generalStoreKey, () => {
    //State
    const projectName = ref();
    const userRole = ref();
    const userFirstName = ref();
    const userLastName = ref();
    const locale = ref(DEFAULT_LANGUAGE_CODE);
    const notificationsCount = ref(0);
    const headerInfo = ref();
    //Getters
    const userFullName = computed(() => {
        if (userFirstName.value && userLastName.value) {
            return `${userFirstName.value} ${userLastName.value}`;
        }
        return userFirstName.value || userLastName.value;
    });
    const getHeaderInfo = computed(() => {
        if (!headerInfo.value) {
            return Injector.get(HEADER_PANEL_API)
                .getHeaderItems()
                .then((result) => {
                setHeaderInfo(result);
                return headerInfo.value;
            });
        }
        else
            return Promise.resolve(headerInfo.value);
    });
    //Actions
    const setHeaderInfo = (headerInfoToSet) => {
        headerInfo.value = headerInfoToSet;
        projectName.value = headerInfoToSet.projectName;
        userFirstName.value = headerInfoToSet.firstName;
        userLastName.value = headerInfoToSet.lastName;
        userLastName.value = headerInfoToSet.lastName;
        locale.value = headerInfoToSet.languageName;
    };
    const setLocale = async (localeArg) => {
        const { getLangNameFromCode } = await languageNameMapImport();
        const langConfig = localeArg && getLangNameFromCode(localeArg);
        if (langConfig) {
            locale.value = localeArg;
            document.body.dir = langConfig.dir;
        }
        else {
            locale.value = DEFAULT_LANGUAGE_CODE;
            document.body.dir = DEFAULT_LANGUAGE_DIRECTION;
        }
    };
    const setNotificationsCount = (count) => {
        notificationsCount.value = Math.max(count, 0);
    };
    const setUserRole = (role) => {
        userRole.value = role || UserRole.Reader;
    };
    return {
        // State
        projectName,
        userRole,
        userFirstName,
        userLastName,
        locale,
        notificationsCount,
        // Getters
        userFullName,
        getHeaderInfo,
        // Actions
        setNotificationsCount,
        setHeaderInfo,
        setLocale,
        setUserRole,
    };
});
